export const bedroomName = (room: number) => (room === 1 ? 'Master' : 'Standard');